import { render } from "./HeroiconsSolidSearchCircle.vue?vue&type=template&id=709d425c"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSearchCircle.vue"]])

export default __exports__